import Service = require("VSS/Service");
import Contribution_Services = require("VSS/Contributions/Services");
import {WidgetStatus,WidgetStatusType} from "TFS/Dashboards/WidgetContracts";
import { LoadingStatus, LoadedEventInfo } from "ModernWidgetContracts/WidgetProps";

//Contains capabilities needed for legacy-interop rendering of both Widget and Configuration experiences hosted by New Platform Dashboards.

export function interpretStatus(legacyWidgetStatus:WidgetStatus): LoadedEventInfo{
    let outcome;
    switch(legacyWidgetStatus.statusType){
        case WidgetStatusType.Success:
            outcome = LoadingStatus.success;
            break;
        case WidgetStatusType.Failure:
            outcome = LoadingStatus.failure;
            break;
        case WidgetStatusType.Unconfigured: //Configuration state is an internal concern of the widget, which the host doesn't participate in.
            outcome = LoadingStatus.success;
            break;
    }
    return {
        outcome: outcome,
        outcomeDescription: legacyWidgetStatus.state
    }
}

export function isFirstPartyContribution(widgetContribution: Contribution){
    return Contribution_Services.ExtensionHelper.hasInternalContent(widgetContribution);
}

export function loadContribution(contributionId: string): IPromise<IExtensionContribution> {
    return Service.getService(Contribution_Services.ExtensionService).getContribution(contributionId).
        then((contribution: IExtensionContribution) => {
            return contribution;
        });
}

/**
 * Retrieves the relative contribution ID portion of the given full contribution ID.
 * The relative contribution ID is the part after the extension name in a full contribution ID.
 * @param contributionId The full contribution ID - {publisher}.{extension}.{contribution}
 */
export function extractRelativeContributionId(contributionId: string): string {
    // The relative contribution ID may contain dots, so we copy the logic from
    // ContributionIdentifier.cs and take everything after the second dot.
    const publisherEndIndex = contributionId.indexOf('.');
    const extensionEndIndex = contributionId.indexOf('.', publisherEndIndex + 1);
    return contributionId.substr(extensionEndIndex + 1);
}